module.exports = __webpack_public_path__ + "b44c1b1a2d1a18906ac3b26c7624ae43-nei_logo_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/header/assets/nei_logo_2x.png
// module id = 573
// module chunks = 0